import {FeaturesEnum} from 'presentation/constants';
import {SearchTermsEnum} from 'presentation/constants/searchTermsEnum';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {ONLY_TELEMEDICINE_SPECIALTIES_CODE} from 'presentation/modules/booking/shared/constants/onlyTelemedicineSpecialties';
import {getSpecialtyBySearch} from 'presentation/utils/GetSpecialtyBySearch';
import {useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {useTheme} from 'styled-components';

export function useHealthCard({specialtyCode}: {specialtyCode: string}) {
	const [searchParams] = useSearchParams();
	const {colors} = useTheme();
	const [openDetailsDrawerState, setOpenDetailsDrawerState] = useState(false);
	const {isEnabled: isOnlyTelemedicineSpecialtyEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_SPECIALTY_ONLY_TELEMEDICINE_CHIP,
	);
	const specialtyBySearch = getSpecialtyBySearch({
		text: searchParams.get('q') || '',
	});

	const isHeadacheParams =
		specialtyBySearch?.toLocaleUpperCase() === SearchTermsEnum.DOR_DE_CABECA;

	const query = isHeadacheParams ? searchParams.get('q') || '' : specialtyBySearch;

	const showOnlyTelemedicineChip =
		isOnlyTelemedicineSpecialtyEnabled &&
		ONLY_TELEMEDICINE_SPECIALTIES_CODE.includes(specialtyCode);

	const handleOpenDetailsDrawer = (e?: React.MouseEvent<HTMLButtonElement>) => {
		e?.stopPropagation();
		setOpenDetailsDrawerState(true);
	};

	const handleCloseDetailsDrawer = () => {
		setOpenDetailsDrawerState(false);
	};

	return {
		colors,
		query,
		openDetailsDrawerState,
		handleOpenDetailsDrawer,
		handleCloseDetailsDrawer,
		showOnlyTelemedicineChip,
	};
}
